import { useState } from 'react';

// Bộ màu NỀN SIDEBAR nhân viên tự chọn. "charcoal" = mặc định (xóa data-sidebar).
// swatch = màu nền hiển thị trên nút chọn (khớp --sb-bg trong index.css).
const THEMES = [
  { key: 'charcoal', label: 'Than chì', swatch: '#14161d' },
  { key: 'navy', label: 'Xanh đêm', swatch: '#0f1a2e' },
  { key: 'indigo', label: 'Tím than', swatch: '#17152a' },
  { key: 'paper', label: 'Trắng ngà', swatch: '#f3f4f7' },
  { key: 'sky', label: 'Xanh nhạt', swatch: '#eaf0fb' },
  { key: 'cream', label: 'Kem ấm', swatch: '#f6f1e7' },
];
const VALID = THEMES.map((t) => t.key).filter((k) => k !== 'charcoal');

function currentTheme() {
  const s = localStorage.getItem('ft-sidebar');
  return VALID.includes(s) ? s : 'charcoal';
}

export default function SidebarPicker() {
  const [theme, setTheme] = useState(currentTheme);

  function pick(key) {
    setTheme(key);
    if (key === 'charcoal') {
      document.documentElement.removeAttribute('data-sidebar');
      localStorage.removeItem('ft-sidebar');
    } else {
      document.documentElement.setAttribute('data-sidebar', key);
      localStorage.setItem('ft-sidebar', key);
    }
  }

  return (
    <div style={{ marginTop: 14 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'var(--sb-label, rgba(255,255,255,0.42))',
          marginBottom: 9,
          paddingLeft: 2,
        }}
      >
        Màu thanh bên
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', paddingLeft: 2 }}>
        {THEMES.map((t) => (
          <button
            key={t.key}
            onClick={() => pick(t.key)}
            title={t.label}
            aria-label={`Nền sidebar ${t.label}`}
            style={{
              width: 22,
              height: 22,
              borderRadius: 6,
              background: t.swatch,
              cursor: 'pointer',
              padding: 0,
              // Luôn nằm trên nền sidebar tối -> dùng màu sáng cứng.
              border: theme === t.key ? '2px solid var(--sb-ring, #ffffff)' : '2px solid var(--sb-swatch-bd, rgba(255,255,255,0.16))',
              boxShadow: theme === t.key ? '0 0 0 1px var(--sb-ring-soft, rgba(255,255,255,0.55))' : 'none',
            }}
          />
        ))}
      </div>
    </div>
  );
}
